/* eslint-disable */
import { Injectable } from '@angular/core';
import { DEGREES_PER_RADIAN, METERS_PER_DEGREE, METERS_PER_MILE, PRECISION } from '../utils/gis.utils';
import { CONSTANTS } from './config.service';
import { LoggerService } from './logger.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class GisService {
  METERS_PER_MILE = METERS_PER_MILE;
  PRECISION = PRECISION; // we just know the storage service returns this
  // approx. from http://gis.stackexchange.com/a/2964
  METERS_PER_DEGREE = METERS_PER_DEGREE;
  DEGREES_PER_RADIAN = DEGREES_PER_RADIAN;
  squaredNearInternalDegrees;
  nearLatRadius;

  constructor(private logger: LoggerService) {
    this.logger.log('Gis constructor', MSRemoteLoggerCategory.GIS_SERVICE);
  }

  getIntLatOrLon(floatLatOrLon) {
    return Math.floor(this.PRECISION * floatLatOrLon);
  }

  getFloatLatOrLon(intLatOrLon) {
    return intLatOrLon / this.PRECISION;
  }

  getIntLatLonFromFloat(latLng) {
    return { lat: this.getIntLatOrLon(latLng.lat), lon: this.getIntLatOrLon(latLng.lng) };
  }

  getLonCorrectionFactor(floatLatDegrees) {
    return Math.cos(floatLatDegrees / this.DEGREES_PER_RADIAN);
  }

  getNearLonRadius(lat) {
    return Math.floor(this.PRECISION * (CONSTANTS.tripRecording.NEAR_METERS / (this.METERS_PER_DEGREE * this.getLonCorrectionFactor(lat))));
  }

  getDistance(lat0, lon0, lat1, lon1, correctionFactor?) {
    const correction = correctionFactor || this.getLonCorrectionFactor((lat0 + lat1) / 2);
    const y = (lat1 - lat0) * this.METERS_PER_DEGREE;
    const x = (lon1 - lon0) * this.METERS_PER_DEGREE * correction;

    return Math.round(Math.pow(Math.pow(x, 2) + Math.pow(y, 2), 0.5));
  }

  getDistanceFromInternalLatLons(lat0, lon0, lat1, lon1) {
    return this.getDistance(
      this.getFloatLatOrLon(lat0),
      this.getFloatLatOrLon(lon0),
      this.getFloatLatOrLon(lat1),
      this.getFloatLatOrLon(lon1)
    );
  }

  // getDistanceBetween = function (loc0, loc1) {
  //     let getLat = function (loc) {
  //             return loc['latitude' in loc ? 'latitude' : 'lat'];
  //         },
  //         getLon = function (loc) {
  //             return loc['longitude' in loc ? 'longitude' : ('long' in loc ? 'long' : 'lon')];
  //         };
  //     return getDistance(getLat(loc0), getLon(loc0), getLat(loc1), getLon(loc1));
  // },

  getLatDegrees(meters) {
    return meters / this.METERS_PER_DEGREE;
  }

  getNearLatInternalDegreesRadius() {
    return this.nearLatRadius;
  }

  getInternalLatDegrees(meters) {
    return Math.floor(this.PRECISION * (meters / this.METERS_PER_DEGREE));
  }

  getInternalLonDegrees(meters, intLat) {
    const lonCorrection = this.getLonCorrectionFactor(this.getFloatLatOrLon(intLat));
    return Math.floor(this.PRECISION * (meters / (this.METERS_PER_DEGREE * lonCorrection)));
  }

  getNearLonInternalDegreesRadius(intLat) {
    return this.getNearLonRadius(this.getFloatLatOrLon(intLat));
  }

  // getMeters: function (internalDegreeDistance) {
  //     let degrees = internalDegreeDistance / PRECISION;
  //     return degrees * METERS_PER_DEGREE;
  // },

  initialize(isLongDistance) {
    this.squaredNearInternalDegrees = Math.pow((CONSTANTS.tripRecording.NEAR_METERS / this.METERS_PER_DEGREE) * this.PRECISION, 2);
    this.nearLatRadius = Math.floor(this.PRECISION * (CONSTANTS.tripRecording.NEAR_METERS / this.METERS_PER_DEGREE));
    return Promise.resolve();
  }
}
